import { useEffect } from 'react';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

export default function MiaAstralPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans selection:bg-gray-200 selection:text-black">
      <title>Mia Astral | De Blog a Imperio Digital | Caso de Éxito Mood Agency</title>
      <meta name="description" content="Descubre cómo Mood Agency transformó la marca de Mia Astral en un ecosistema digital escalable, aumentando los ingresos en un 160% y los suscriptores en un 600%." />
      <meta name="keywords" content="Mia Astral, transformación digital, sitio de membresía, estrategia ecommerce, desarrollo web" />
      
      <Navbar />
      
      {/* Hero Section - Clean & Minimal like Home */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden bg-white">
        {/* Background Ripple Effect (Same as Home) */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
          <div className="absolute w-[60vw] h-[60vw] bg-[radial-gradient(circle,var(--tw-gradient-stops))] from-gray-200 via-gray-100/50 to-transparent rounded-full blur-[80px] opacity-100 z-0"></div>
          <div className="w-[90vw] h-[90vw] border border-gray-200 rounded-full absolute opacity-40"></div>
          <div className="w-[70vw] h-[70vw] border border-gray-300 rounded-full absolute opacity-50"></div>
          <div className="w-[50vw] h-[50vw] border border-gray-300 rounded-full absolute opacity-60"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-6 text-center">
          <div className="mb-8 animate-fade-in-up">
            <span className="font-display text-[10px] tracking-[0.4em] text-gray-400 uppercase">
              CASO DE ÉXITO 2012 - ACTUALIDAD
            </span>
          </div>
          
          <h1 className="font-display text-[12vw] md:text-[8vw] leading-none font-bold uppercase tracking-tighter text-gray-900 mb-8 animate-fade-in-up delay-100">
            MIA ASTRAL
          </h1>
          
          <p className="max-w-2xl mx-auto font-sans text-xl text-gray-500 font-light leading-relaxed animate-fade-in-up delay-200">
            Transformando un blog en un imperio digital de suscripción escalable.
          </p>
        </div>
      </section>

      {/* Key Metrics - Minimalist Grid */}
      <section className="py-20 px-6 bg-white border-t border-gray-100">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">600%</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Crecimiento de Tráfico</p>
          </div>
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">160%</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Aumento de Ingresos</p>
          </div>
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">33k+</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Suscriptores de Pago</p>
          </div>
        </div>
      </section>

      {/* The Context - Clean Typography */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mb-12 uppercase">El Contexto</h2>
          <p className="font-sans text-xl md:text-2xl text-gray-500 leading-relaxed font-light">
            Mia Astral revolucionó la astrología moderna enfocándose en el crecimiento personal y el coaching. Sin embargo, su hogar digital era demasiado pequeño. Un simple blog no podía contener la visión: una plataforma integral para el empoderamiento, la educación y la comunidad.
          </p>
        </div>
      </section>

      {/* Visual Break - Full Width Image */}
      <section className="w-full h-[80vh] overflow-hidden">
        <img 
          src="/assets/images/portfolio/mia/header.jpg" 
          alt="Universo Mia Astral" 
          className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-1000 ease-out"
        />
      </section>

      {/* The Challenge - Minimal List */}
      <section className="py-32 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-20 items-center">
          <div>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 mb-8 uppercase leading-tight">
              Dolores de Crecimiento<br/>en Retrógrado
            </h2>
            <p className="font-sans text-lg text-gray-500 leading-relaxed mb-12">
              El éxito trae su propia gravedad. A medida que la popularidad de Mia explotaba, su infraestructura comenzó a fallar. Los eventos de alto tráfico colapsaban el sitio y la monetización manual creaba fricción.
            </p>
          </div>
          <div className="space-y-12">
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Infraestructura Frágil</h3>
              <p className="font-sans text-gray-500">El sitio no podía manejar picos de más de 50k usuarios concurrentes durante eventos astrológicos importantes.</p>
            </div>
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Pérdida de Ingresos</h3>
              <p className="font-sans text-gray-500">Procesos de pago complejos causaban tasas de abandono del carrito del 70%.</p>
            </div>
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Ceguera de Datos</h3>
              <p className="font-sans text-gray-500">Sin una vista unificada del viaje del cliente o el valor de vida para optimizar el crecimiento.</p>
            </div>
          </div>
        </div>
      </section>

      {/* The Solution - Grid Layout */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="mb-20">
            <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 uppercase">La Solución</h2>
          </div>

          <div className="grid md:grid-cols-3 gap-px bg-gray-200 border border-gray-200">
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Plataforma</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Diseñamos y optimizamos la infraestructura técnica para soportar picos de hasta 5,000 usuarios concurrentes sin interrupciones, garantizando una experiencia de compra fluida y segura en el ecommerce durante lanzamientos críticos.
              </p>
            </div>
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Membresía</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Diseñamos un modelo de suscripción escalonado ("Sección Exclusiva") que convirtió a lectores casuales en miembros comprometidos, creando un flujo de ingresos recurrente y predecible.
              </p>
            </div>
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Ecosistema</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Integramos webinars, venta de productos físicos y venta de entradas para eventos en un único panel unificado, proporcionando una experiencia de usuario sin fricciones en todos los puntos de contacto.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Impact - Minimal Statistics */}
      <section className="py-32 px-6 bg-black text-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-20 text-center uppercase tracking-widest">Impacto Global</h2>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-12 text-center">
            <div>
              <div className="font-display text-4xl md:text-5xl font-bold mb-2">1.4M+</div>
              <div className="font-sans text-xs text-gray-500 uppercase tracking-[0.2em]">Fans en Facebook</div>
            </div>
            <div>
              <div className="font-display text-4xl md:text-5xl font-bold mb-2">1.6M+</div>
              <div className="font-sans text-xs text-gray-500 uppercase tracking-[0.2em]">Seguidores Instagram</div>
            </div>
            <div>
              <div className="font-display text-4xl md:text-5xl font-bold mb-2">213K+</div>
              <div className="font-sans text-xs text-gray-500 uppercase tracking-[0.2em]">Subs en YouTube</div>
            </div>
            <div>
              <div className="font-display text-4xl md:text-5xl font-bold mb-2">281K+</div>
              <div className="font-sans text-xs text-gray-500 uppercase tracking-[0.2em]">Seguidores Twitter</div>
            </div>
          </div>

          <div className="mt-32 max-w-3xl mx-auto text-center">
            <p className="font-display text-2xl md:text-3xl leading-tight">
              "Mood Agency no solo construyó un sitio web. Construyeron el motor que impulsa todo mi modelo de negocio."
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
